import { useContext } from 'react'
import { CheckboxProviderContext } from '../providers/CheckboxProvider'

export default function useCheckboxes() {
  return useContext(CheckboxProviderContext)
}
